<template>
  <section>
    <b-tabs
      v-if="!loading"
      :value="activeTabIndex"
      @input="onChangeTab"
    >
      <b-tab
        :title="$tk('ClientPortal.Catalogs.CatalogItems')"
      >
        <CatalogItems
          v-if="visitedTabs.includes(0)"
          :catalog-id="catalogId"
        />
      </b-tab>
      <b-tab
        v-if="wrapper.canEdit"
        :title="$tk('ClientPortal.Catalogs.Settings')"
      >
        <CatalogSettings
          v-if="visitedTabs.includes(1)"
          :catalog-id="catalogId"
        />
      </b-tab>
      <b-tab
        v-if="configuration.clientConfiguration.showCatalogSet"
        :title="$tk('ClientPortal.Catalogs.Sets')"
      >
        <CatalogSets
          v-if="visitedTabs.includes(wrapper.canEdit ? 2 : 1)"
          :catalog-id="catalogId"
          :can-edit="wrapper.canEdit"
        />
      </b-tab>
      <b-tab
        v-if="wrapper.canEdit"
        :title="$tk('ClientPortal.Catalogs.Logs')"
      >
        <CatalogLogs
          v-if="visitedTabs.includes(3)"
          :catalog-id="catalogId"
        />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import CatalogsService from '@/api/client/catalogs.service'
import { mapGetters } from 'vuex'
import store from '@/store'
import CatalogLogs from './CatalogLogs.vue'
import CatalogItems from './CatalogItems.vue'
import CatalogSets from './CatalogSets.vue'
import CatalogSettings from './CatalogSettings.vue'

export default {
  components: {
    CatalogLogs,
    CatalogItems,
    CatalogSets,
    CatalogSettings,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    catalogId: String,
  },
  data() {
    return {
      visitedTabs: [],
      wrapper: {},
      loading: true,
    }
  },
  computed: {
    activeTabIndex() {
      const route = this.$route.hash.toLowerCase()
      return this.tabHashes.findIndex(x => x === route) || 0
    },
    tabHashes() {
      if (this.wrapper.canEdit) { return ['#catalog-items', '#settings', '#sets', '#logs'] }
      return ['#catalog-items', '#sets']
    },
    ...mapGetters(['configuration']),
  },
  watch: {
    '$route.params.accountId': 'onAccountChange',
  },
  async beforeCreate() {
    store.commit('verticalMenu/changeBreadcrumbs', '')
    let catalogs = {}
    try {
      catalogs = await CatalogsService.getCatalogs(this.$route.params.accountId)
      catalogs.push(...await CatalogsService.getSharedCatalogs(this.$route.params.accountId))
    } catch {
      // toast
      this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
    } finally {
      const catalogName = catalogs.find(catalog => catalog.encodedId === this.catalogId).name
      this.$set(this.$route.meta, 'pageTitle', catalogName)
      this.$set(this.$route.meta.breadcrumb[2], 'text', catalogName)
      store.commit('verticalMenu/changeBreadcrumbs', catalogName)
    }
  },
  async mounted() {
    this.loading = true
    const route = this.$route.hash.toLowerCase()
    const { catalogId, accountId } = this.$route.params
    this.wrapper = await CatalogsService.getCatalogSettings(catalogId, accountId)
    this.visitedTabs.push(this.tabHashes.findIndex(x => x === route) || 0)
    this.loading = false
  },
  methods: {
    onChangeTab(tab) {
      if (tab === 2 && !this.configuration.clientConfiguration.showCatalogSet) { tab += 1 }
      if (!this.visitedTabs.includes(tab)) {
        this.visitedTabs.push(tab)
      }

      const hash = this.tabHashes[tab]
      this.$router.replace({ hash })
    },
    onAccountChange() {
      this.$router.push(`/${this.$route.params.accountId}/catalogs`)
    },
  },
}
</script>
